/**
 * UID-280 — the custom-part revision label (UID-256). Shows the display revision
 * (e.g. "Rev 1") for custom parts. Renders nothing when the sourceable carries no
 * `rev` (catalog parts), so every call site can pass `sourceable.rev`
 * unconditionally and the show/hide policy stays on the server.
 *
 * The design comp (`Fictiv Platform.dc.html`) specifies TWO DISTINCT treatments —
 * this is a placement difference, not merely a size one, which is why `variant`
 * names them rather than a vague `sm`/`md`:
 *
 * - `band` (default) — a full-bleed caption strip INSIDE the bordered thumbnail
 *   frame, below the image, separated by an inset top hairline. Used on the
 *   parts-library rows (`.dc.html:1398`, 60px). NOT the part-detail main thumb:
 *   the comp shows a plain bordered image box there (see `PartDetailThumb`).
 * - `caption` — a bare centred label BELOW and OUTSIDE the thumbnail box, with no
 *   hairline, no background and no border. Used on the small thumbs: cart lines
 *   (:2221, 40px) and the RFQ review parts list (:4183, 52px). The thumbnail keeps
 *   its full square area in this treatment — the label does not eat into it.
 */
export function PartRevBand({
  rev,
  variant,
}: {
  readonly rev?: string | null | undefined
  readonly variant?: 'band' | 'caption'
}) {
  if (!rev) {
    return null
  }
  return <div className={variant === 'caption' ? 'part-rev-caption' : 'part-rev-band'}>{rev}</div>
}
